'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { VisuallyHidden } from '@web/atoms';
import { useReporter } from '../../reporter';
import { ResponsiveImage } from '../ResponsiveImage';
import fallbackLogo from './ollie-logo.svg';
import { LogoImgContainer, LogoLink } from './styles.js';
import { logoClicked } from './events';

export const HeaderLogo = ({
  logoImg,
  logoUrl = '/',
  logoSrText = 'Ollie home',
}) => {
  const reporter = useReporter();
  const onLogoClick = () => {
    reporter.tag(logoClicked(window.location.pathname));
  };

  return (
    <LogoLink href={logoUrl} onClick={onLogoClick}>
      <LogoImgContainer>
        <ResponsiveImage {...(logoImg ?? fallbackLogo)} alt="Ollie logo" />
      </LogoImgContainer>
      <VisuallyHidden>{logoSrText}</VisuallyHidden>
    </LogoLink>
  );
};

HeaderLogo.propTypes = {
  logoImg: PropTypes.object,
  logoUrl: PropTypes.string,
  logoSrText: PropTypes.string,
};
